webpackJsonp([1],{

/***/ 112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isTouchscreen;
function isTouchscreen() {
    return 'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(114)
}
var Component = __webpack_require__(16)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(135),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-34131a12",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 114:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 115:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['isTouch'],
    data: function data() {
        return {
            isEmailError: false,
            isLocked: false,
            isSent: false,
            email: '',
            message: ''
        };
    },
    mounted: function mounted() {
        this.$refs.email.focus();
    },


    methods: {
        send: function send(e) {
            if (this.isSent) {
                return;
            }
            e.isSendEvent = true;
            if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.email)) {
                this.isEmailError = true;
                this.$refs.email.focus();
                return;
            }
            this.isEmailError = false;
            this.isLocked = true;
            __WEBPACK_IMPORTED_MODULE_0_axios__["post"]('/api/contact', {
                email: this.email,
                message: this.message
            });
            this.isSent = true;
        },

        preventClose: function preventClose(e) {
            if (!this.isSent || e.isSendEvent) {
                e.stopPropagation();
            }
        }
    }
});

/***/ }),

/***/ 135:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal__mask",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal__wrapper"
  }, [_c('table', {
    staticClass: "modal__container",
    on: {
      "click": _vm.preventClose
    }
  }, [_c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    ref: "email",
    staticClass: "field email",
    class: {
      error: _vm.isEmailError
    },
    attrs: {
      "disabled": _vm.isLocked,
      "type": "email",
      "placeholder": "Your email",
      "spellcheck": "false"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }, function($event) {
        _vm.isEmailError = false
      }],
      "change": function($event) {
        _vm.isEmailError = false
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "field message",
    attrs: {
      "disabled": _vm.isLocked,
      "placeholder": "Message"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "modal__button",
    class: {
      touch: _vm.isTouch
    },
    on: {
      "click": _vm.send
    }
  }, [_c('div', {
    staticClass: "modal__button__blinder",
    class: {
      active: _vm.isSent
    }
  }, [_c('div', {
    staticClass: "modal__button__message"
  }, [_vm._v("sent")])]), _vm._v("\n                        send\n                    ")])])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 136:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    on: {
      "mousemove": _vm.onCanvasCursor
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('canvas', {
    staticClass: "bubble-canvas"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content__name"
  }, [_vm._v("Andrey Romancev")]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "media__icon-container"
  }, [_c('a', {
    staticClass: "media__icon",
    attrs: {
      "href": "https://twitter.com/aromancev"
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 67 67"
    },
    attrs: {
      "height": "32px",
      "version": "1.1",
      "viewBox": "0 0 67 67",
      "width": "32px",
      "xml:space": "preserve",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('path', {
    staticStyle: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    },
    attrs: {
      "d": "M37.167,22.283c-2.619,0.953-4.274,3.411-4.086,6.101  l0.063,1.038l-1.048-0.127c-3.813-0.487-7.145-2.139-9.974-4.915l-1.383-1.377l-0.356,1.017c-0.754,2.267-0.272,4.661,1.299,6.271  c0.838,0.89,0.649,1.017-0.796,0.487c-0.503-0.169-0.943-0.296-0.985-0.233c-0.146,0.149,0.356,2.076,0.754,2.839  c0.545,1.06,1.655,2.097,2.871,2.712l1.027,0.487l-1.215,0.021c-1.173,0-1.215,0.021-1.089,0.467  c0.419,1.377,2.074,2.839,3.918,3.475l1.299,0.444l-1.131,0.678c-1.676,0.976-3.646,1.526-5.616,1.568  C19.775,43.256,19,43.341,19,43.405c0,0.211,2.557,1.397,4.044,1.864c4.463,1.377,9.765,0.783,13.746-1.568  c2.829-1.673,5.657-5,6.978-8.221c0.713-1.716,1.425-4.851,1.425-6.354c0-0.975,0.063-1.102,1.236-2.267  c0.692-0.678,1.341-1.419,1.467-1.631c0.21-0.403,0.188-0.403-0.88-0.043c-1.781,0.636-2.033,0.551-1.152-0.402  c0.649-0.678,1.425-1.907,1.425-2.267c0-0.063-0.314,0.042-0.671,0.233c-0.377,0.212-1.215,0.53-1.844,0.72l-1.131,0.361l-1.027-0.7  c-0.566-0.381-1.361-0.805-1.781-0.932C39.766,21.902,38.131,21.944,37.167,22.283z M33,64C16.432,64,3,50.569,3,34S16.432,4,33,4  s30,13.431,30,30S49.568,64,33,64z"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "media__icon",
    attrs: {
      "href": "https://www.linkedin.com/in/romancev/"
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 65 65"
    },
    attrs: {
      "height": "32px",
      "version": "1.1",
      "viewBox": "0 0 65 65",
      "width": "32px",
      "xml:space": "preserve",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('path', {
    staticStyle: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    },
    attrs: {
      "d": "M50.837,48.137V36.425c0-6.275-3.35-9.195-7.816-9.195  c-3.604,0-5.219,1.983-6.119,3.374V27.71h-6.79c0.09,1.917,0,20.427,0,20.427h6.79V36.729c0-0.609,0.044-1.219,0.224-1.655  c0.49-1.22,1.607-2.483,3.482-2.483c2.458,0,3.44,1.873,3.44,4.618v10.929H50.837z M22.959,24.922c2.367,0,3.842-1.57,3.842-3.531  c-0.044-2.003-1.475-3.528-3.797-3.528s-3.841,1.524-3.841,3.528c0,1.961,1.474,3.531,3.753,3.531H22.959z M34,64  C17.432,64,4,50.568,4,34C4,17.431,17.432,4,34,4s30,13.431,30,30C64,50.568,50.568,64,34,64z M26.354,48.137V27.71h-6.789v20.427  H26.354z"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "media__icon",
    attrs: {
      "href": "https://github.com/aromancev"
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 512 512"
    },
    attrs: {
      "height": "32px",
      "version": "1.1",
      "viewBox": "0 0 512 512",
      "width": "32px",
      "xml:space": "preserve",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('path', {
    attrs: {
      "d": "M256,32C132.3,32,32,134.8,32,261.7c0,101.5,64.2,187.5,153.2,217.9c11.2,2.1,15.3-5,15.3-11.1   c0-5.5-0.2-19.9-0.3-39.1c-62.3,13.9-75.5-30.8-75.5-30.8c-10.2-26.5-24.9-33.6-24.9-33.6c-20.3-14.3,1.5-14,1.5-14   c22.5,1.6,34.3,23.7,34.3,23.7c20,35.1,52.4,25,65.2,19.1c2-14.8,7.8-25,14.2-30.7c-49.7-5.8-102-25.5-102-113.5   c0-25.1,8.7-45.6,23-61.6c-2.3-5.8-10-29.2,2.2-60.8c0,0,18.8-6.2,61.6,23.5c17.9-5.1,37-7.6,56.1-7.7c19,0.1,38.2,2.6,56.1,7.7   c42.8-29.7,61.5-23.5,61.5-23.5c12.2,31.6,4.5,55,2.2,60.8c14.3,16.1,23,36.6,23,61.6c0,88.2-52.4,107.6-102.3,113.3   c8,7.1,15.2,21.1,15.2,42.5c0,30.7-0.3,55.5-0.3,63c0,6.1,4,13.3,15.4,11C415.9,449.1,480,363.1,480,261.7   C480,134.8,379.7,32,256,32z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "contacts"
  }, [_c('div', {
    staticClass: "email"
  }, [_c('transition', {
    attrs: {
      "name": "bubble"
    }
  }, [(_vm.isBubbleShown) ? _c('div', {
    staticClass: "copy-bubble"
  }, [_vm._v("copied to clipboard")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "link",
    on: {
      "click": _vm.copyText
    }
  }, [_vm._v("a@romancev.com")])], 1)])]), _vm._v(" "), (_vm.isContactShown) ? _c('contact', {
    attrs: {
      "isTouch": _vm.isTouch
    },
    on: {
      "close": function($event) {
        return _vm.showContacts(false)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 137:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('home')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__app__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '.app',
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__app___default.a }
});

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(56)
}
var Component = __webpack_require__(16)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(137),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 56:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_home_home__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_home_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_home_home__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    components: {
        Home: __WEBPACK_IMPORTED_MODULE_0__components_home_home___default.a
    }
});

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(60)
}
var Component = __webpack_require__(16)(
  /* script */
  __webpack_require__(61),
  /* template */
  __webpack_require__(136),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c6a3ca46",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 60:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bubbles__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_device__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contact__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__contact__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Contact: __WEBPACK_IMPORTED_MODULE_2__contact___default.a
    },

    data: function data() {
        return {
            isTouch: Object(__WEBPACK_IMPORTED_MODULE_1__utils_device__["a" /* isTouchscreen */])(),
            isContactShown: window.location.hash === '#contact',
            isBubbleShown: false
        };
    },
    created: function created() {
        this.bubbles = null;
        this.bounce = !this.isTouch;

        window.addEventListener('deviceorientation', this.onOrientation, true);
        window.onhashchange = function () {
            this.isContactShown = window.location.hash === '#contact';
        }.bind(this);
    },
    mounted: function mounted() {
        this.bubbles = new __WEBPACK_IMPORTED_MODULE_0__bubbles__["a" /* BubbleDrawer */](document.getElementsByClassName('bubble-canvas')[0]);
        this.bubbles.start();
    },


    methods: {
        onCanvasCursor: function onCanvasCursor(e) {
            if (!this.bounce || this.isContactShown) return;

            this.bubbles.setBouncerPosition(e.clientX, e.clientY);
        },

        onOrientation: function onOrientation(e) {
            this.bubbles.setTilt(e.gamma);
        },

        copyText: function copyText(e) {
            var _this = this;

            var el = document.createElement('input');
            el.value = e.currentTarget.textContent;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);

            this.isBubbleShown = true;
            if (this.bubbleTimer) {
                clearTimeout(this.bubbleTimer);
            }
            this.bubbleTimer = setTimeout(function () {
                _this.isBubbleShown = false;
            }, 1000);
        },

        showContacts: function showContacts(isShown) {
            window.location.hash = isShown ? 'contact' : '';
        }
    }
});

/***/ }),

/***/ 62:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BubbleDrawer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_hypot__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_hypot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_hypot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_is__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);






var MIN_RADIUS = 10;
var MAX_RADIUS = 150;
var BUBBLE_RATE = 0.7;
var BOUNCE_SPEED = 100;
var BOUNCER_RADIUS = 70;
var BOUNCER_BOUNCE_SPEED = 2000;

var Bubble = function () {
    function Bubble(x, y, radius) {
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Bubble);

        this.radius = radius || Math.random() * (MAX_RADIUS - MIN_RADIUS) + MIN_RADIUS;
        this.x = x || Math.random() * window.innerWidth;
        this.y = y || window.innerHeight + this.radius;
    }

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(Bubble, [{
        key: 'draw',
        value: function draw(ctx) {
            ctx.beginPath();
            ctx.arc(this.x, this.y, this.radius, 0, 2 * Math.PI, false);
            ctx.closePath();
        }
    }, {
        key: 'rise',
        value: function rise(speedFactor, angle) {
            var delta = (MAX_RADIUS + MIN_RADIUS - this.radius) * speedFactor;
            angle = angle * (Math.PI / 180);
            this.x += Math.cos(angle) * delta;
            this.y -= Math.sin(angle) * delta;
        }
    }, {
        key: 'bounce',
        value: function bounce(speedFactor, bubble, speed) {
            if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_is___default()(this, bubble)) return;
            var distance = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_hypot___default()(bubble.x - this.x, bubble.y - this.y);
            var maxRange = bubble.radius + this.radius;

            if (distance > maxRange) return;

            var angle = Math.atan2(this.y - bubble.y, this.x - bubble.x);
            var radiusFactor = bubble.radius / (this.radius + bubble.radius);
            var mergeFactor = 1 - distance / maxRange;
            var delta = (speed || BOUNCE_SPEED) * mergeFactor * radiusFactor * speedFactor;

            this.x += Math.cos(angle) * delta;
            this.y += Math.sin(angle) * delta;
        }
    }, {
        key: 'isOutOfScreen',
        value: function isOutOfScreen() {
            if (this.x < -this.radius) return true;
            if (this.x > window.innerWidth + this.radius) return true;
            if (this.y < -this.radius) return true;
            if (this.y > window.innerHeight + MAX_RADIUS * 2) return true;

            return false;
        }
    }]);

    return Bubble;
}();

var BubbleDrawer = function () {
    function BubbleDrawer(canvasElement) {
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, BubbleDrawer);

        this.element = canvasElement;

        this.isRunning = false;
        this.frameTime = null;
        this.frameFactor = null;
        this.bubbles = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();
        this.spawnTimer = null;
        this.bouncer = null;
        this.riseAngle = 90;
    }

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(BubbleDrawer, [{
        key: 'spawnBubble',
        value: function spawnBubble() {
            var _this = this;

            this.bubbles.add(new Bubble());
            this.spawnTimer = setTimeout(function () {
                return _this.spawnBubble();
            }, 1000 * 1000 / BUBBLE_RATE / window.innerWidth);
        }
    }, {
        key: 'start',
        value: function start() {
            this.isRunning = true;
            this.iterateFrame();

            this.bubbles.add(new Bubble(window.innerWidth / 2, window.innerHeight + MIN_RADIUS, MIN_RADIUS));
            this.spawnBubble();
        }
    }, {
        key: 'stop',
        value: function stop() {
            this.isRunning = false;
            clearTimeout(this.spawnTimer);
            this.spawnTimer = null;
        }
    }, {
        key: 'setBouncerPosition',
        value: function setBouncerPosition(x, y) {
            if (!this.bouncer) {
                this.bouncer = new Bubble(x, y, BOUNCER_RADIUS);
            } else {
                this.bouncer.x = x;
                this.bouncer.y = y;
            }
        }
    }, {
        key: 'setTilt',
        value: function setTilt(angle) {
            if (angle > 90) angle = 90;else if (angle < -90) angle = -90;

            this.riseAngle = 90 + angle;
        }
    }, {
        key: 'process',
        value: function process() {
            this.element.width = window.innerWidth;
            this.element.height = window.innerHeight;
            var ctx = this.element.getContext('2d');

            ctx.fillStyle = '#464178';
            ctx.strokeStyle = '#6058a1';
            ctx.lineWidth = 5;

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.bubbles), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var b = _step.value;

                    b.draw(ctx);
                    ctx.stroke();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.bubbles), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _b = _step2.value;

                    _b.draw(ctx);
                    ctx.fill();
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            if (this.bouncer) {
                ctx.save();

                ctx.globalCompositeOperation = 'destination-out';
                this.bouncer.draw(ctx);
                ctx.fill();

                ctx.globalCompositeOperation = 'source-atop';
                this.bouncer.draw(ctx);
                ctx.stroke();

                ctx.restore();
            }

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.bubbles), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var b1 = _step3.value;

                    b1.rise(this.frameFactor, this.riseAngle);
                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.bubbles), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                            var b2 = _step4.value;

                            b1.bounce(this.frameFactor, b2);
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }
                        } finally {
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }

                    if (this.bouncer) {
                        b1.bounce(this.frameFactor, this.bouncer, BOUNCER_BOUNCE_SPEED);
                    }

                    if (b1.isOutOfScreen()) this.bubbles.delete(b1);
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            this.iterateFrame();
        }
    }, {
        key: 'iterateFrame',
        value: function iterateFrame() {
            var _this2 = this;

            if (!this.isRunning) return;

            var time = new Date().getTime();
            this.frameFactor = this.frameTime ? (time - this.frameTime) / 1000 : 0;
            this.frameTime = time;

            window.requestAnimationFrame(function () {
                return _this2.process();
            });
        }
    }]);

    return BubbleDrawer;
}();

/***/ })

},[51]);


// WEBPACK FOOTER //
// static/js/app.ada48035c49bdff7d1c6.js